// src/reports/pages/TelecomSelfReportPrint.tsx
import React from "react";
import { useParams } from "react-router-dom";
import { ExecutiveNarrative } from "@/reports/ExecutiveNarrative";
import { TrafficLightBars } from "@/components/report/TrafficLightBars";
import { FunctionRadar } from "@/components/report/FunctionRadar";
import { RecommendationsByFunction } from "@/reports/RecommendationsByFunction";
import "@/reports/print.min.css";

/**
 * PRINT-ONLY REPORT PAGE
 * - No sticky/fixed/min-h-screen
 * - Explicit page breaks via .p1, .p2, .p3
 * - TrafficLightBars rendered twice: compact on p1, full on p2
 */
export default function TelecomSelfReportPrint() {
  const { assessmentId } = useParams<{ assessmentId: string }>();

  // TODO: Replace with actual data hooks
  const orgName = "Sample Telecom Operator";
  const dateStr = new Date().toLocaleDateString();
  const functionScores = [
    { fn: "Govern" as const, you: 75 },
    { fn: "Identify" as const, you: 68 },
    { fn: "Protect" as const, you: 82 },
    { fn: "Detect" as const, you: 55 },
    { fn: "Respond" as const, you: 62 },
    { fn: "Recover" as const, you: 70 },
  ];

  const barScores = functionScores.map(s => ({ fn: s.fn, value: s.you }));
  const responses = []; // TODO: fetch actual responses

  return (
    <div className="print-root">
      {/* PAGE 1: Executive Summary + About + Compact Bars */}
      <div className="p1">
        <ExecutiveNarrative
          orgName={orgName}
          dateStr={dateStr}
          functionScores={functionScores}
        />
        <TrafficLightBars
          scores={barScores}
          variant="compact"
        />
      </div>

      {/* PAGE 2: Full Bars + Radar */}
      <div className="p2">
        <TrafficLightBars
          scores={barScores}
          variant="full"
        />
        <FunctionRadar scores={barScores} />
      </div>

      {/* PAGE 3+: Recommendations */}
      <div className="p3">
        <RecommendationsByFunction responses={responses} />
      </div>
    </div>
  );
}
